import { FormControl } from '@angular/forms';

import * as card_validator from 'card-validator';

export function pfCreditCardValidator(control: FormControl) {
    const valid = card_validator.number(control.value);
    return valid.isValid || valid.isPotentiallyValid ? null : {cardNumber: {valid: false}};
}
